export default __webpack_public_path__ + "static/media/formulaBanner.5fafa10a.jpg";